import { ReactNode } from 'react';
import { PlayerLeaderboardSkeleton } from '../leaderboard/player-leaderboard';
import { Skeleton } from '../../../../../packages/ui/components/skeleton';

export const TriviaLeaderboardSectionLayout = ({
  children,
  tabs,
}: {
  children: ReactNode;
  tabs: ReactNode;
}) => {
  return (
    <div className="bg-midnightExpressShade3 md:bg-midnightExpressShade2 min-h-full rounded-[10px] px-0 md:px-6 md:pb-3 md:pt-[10px]">
      <div className="trivia-rumble-game-navigation-items flex items-center justify-between gap-5 pb-5 pr-0 pt-0 md:pt-[30px]">
        {tabs}
      </div>
      <div className="relative h-full rounded-[10px] md:mx-0">{children}</div>
    </div>
  );
};

export const TriviaLeaderboardSectionSkeleton = () => {
  return (
    <TriviaLeaderboardSectionLayout
      tabs={
        <>
          <Skeleton className="h-[30px] w-full" />
          <Skeleton className="h-[30px] w-full" />
          <Skeleton className="h-[30px] w-full" />
        </>
      }
    >
      <PlayerLeaderboardSkeleton compact={false} />
    </TriviaLeaderboardSectionLayout>
  );
};
